<div id="wrapper">
	<div>
		<app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
	</div>
	<div>
		<app-tab-nav
			[visible]="false"
			(updatePostpaid)="this.postpago=$event"
			(updatePrepaid)="this.prepago=$event"
			(updateFixed)="this.telefoniaFijo=$event"
			(updateTotalAccountList)="this.totalAccountList=$event"
			(updateCurrentList)="this.currentList=$event"
			(updateSelectBan)="this.selectBan=$event"
			(updateInitializeData)="this.initializeData()">
		</app-tab-nav>
	</div>
	<div class="allcont logsize m-top-i">
		<div class="basicrow ">
			<div class="container">
				<div class="">
					<div class="fulltitle  f-btitle autodef">
						<span class="icon-dash-13"></span> Soporte Técnico Netflix
					</div>
				</div>
			</div>
		</div>
		<div class="basicrow m-top-i graybg">
			<div class="container ">
				<div class="row ">
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 text-left row-full">
						<div class="basicrow">
							<div class="row">
								<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
									<div class="basicrow f-big roboto-l">
										Centro de Ayuda Netflix
									</div>
								</div>
								<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-top">
									<div class="basicrow f-bmed roboto-b">
										Navegación dentro del sitio de Netflix, la aplicación y sus funcionalidades:
									</div>
									<div class="basicrow f-med line-def-i m-top-ii" style="text-align: justify;">
										Solución de mensajes de error en la navegación de Netflix, creación o cambios de
										perfiles, entre otros.
									</div>
								</div>
								<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-top">
									<div class="basicrow h-mtop f-bmed roboto-b">
										Consultas relacionadas a su cuenta:
									</div>
									<div class="basicrow f-med line-def-i m-top-ii" style="text-align: justify;">
										Recuperación de contraseña, actualización de dirección de correo electrónico,
										cambios de plan, preguntas sobre su balance de promociones, entre otros.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="basicrow m-top-ii">
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-lg-offset-4 col-md-offset-3">
							<a href="https://help.netflix.com/es" target="_blank" rel="noopener noreferrer" class="btns blue vcenter">
								<span class="tabcell">
									Ir a Soporte de Netflix&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
								</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="basicrow roboto-r f-med f-black">
			<div class="container m-top-i">
				<div class="row ">
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 text-left row-full">
						<div class="basicrow">
							<div class="row">
								<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
									<div class="basicrow f-big roboto-l">
										Centro de Ayuda Claro
									</div>
								</div>
								<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-top">
									<div class="basicrow f-bmed roboto-b">
										Asistencia con la cuenta de Claro, y los dispositivos o servicios provistos por
										Claro
									</div>
									<div class="basicrow f-med line-def-i m-top-ii">
										Solución de problemas y preguntas sobre la cuenta de Claro y los dispositivos o
										servicios provistos por Claro.
									</div>
								</div>
								<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-top">
									<div class="basicrow h-mtop f-bmed roboto-b">
										Preguntas sobre la Factura
									</div>
									<div class="basicrow f-med line-def-i m-top-ii">
										Preguntas sobre cómo el cargo de Netflix se presentará en la factura.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="basicrow m-top-ii">
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-lg-offset-4 col-md-offset-3">
							<a href="#" ui-sref="support" class="btns blue vcenter">
								<span class="tabcell">
									Contáctanos&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
								</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="basicrow m-top-i graybg">
			<div class="container ">
				<div class="row ">
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10 text-left row-full">
						<div class="basicrow">
							<div class="row">
								<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
									<div class="basicrow f-big roboto-l">
										En Conjunto
									</div>
								</div>
								<div class="col-xs-12    m-top">
									<div class="basicrow f-bmed roboto-b">
										Conectividad
									</div>
									<div class="basicrow f-med line-def-i m-top-ii" style="text-align: justify;">
										Asuntos y/o problemas de conectividad a cualquier fuente de Internet puede
										causar que la aplicación de Netflix no se descargue ni funcione correctamente.
										Si el usuario no tiene conectividad a Internet, debe comunicarse con su
										proveedor de Internet. Si el usuario tiene conectividad a Internet, entonces el
										usuario debe confirmar que el dispositivo que está utilizando tenga todas las
										actualizaciones al día.
									</div>
									<div class="basicrow f-med line-def-i m-top-ii" style="text-align: justify;">
										Una vez el usuario confirme que tiene conectividad a Internet y que su
										dispositivo tiene las actualizaciones al día, debe comunicarse al Help Center de
										Netflix para recibir la información de los pasos de asistencia técnica a seguir.
										El usuario también podrá comunicarse con Servicio al cliente de Claro para que
										sus representantes reporten el problema a Netflix.
									</div>
								</div>
								<div class="col-xs-12   m-top">
									<div class="basicrow f-bmed roboto-b">
										Recuperación de las credenciales de Netflix:
									</div>
									<div class="basicrow f-med line-def-i m-top-ii" style="text-align: justify;">
										Los usuarios que tengan dificultad identificando los detalles de sus
										credenciales de Netflix, no podrán acceder a su servicio de Netflix sin
										asistencia adicional. 

										Si el usuario ha olvidado su correo electrónico, debe pulsar la alternativa para
										recuperar el mismo presentada en esta pantalla. Si el usuario ha olvidado su
										contraseña, debe pulsar la alternativa para recuperar la misma presentada en
										esta pantalla o visitar directamente la página web de Netflix y solicitar ayuda
										al iniciar su sesión.

										Los representantes de servicio de Netflix y Claro están debidamente preparados
										para orientar y asistir a los usuarios en la recuperación de sus credenciales de
										Netflix.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<app-footer></app-footer>
</div>
